import * as React from 'react';

var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "motorway-svg-fill",
    fill: "#E72F3D",
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "motorway-svg-fill",
    fill: "#FFF",
    d: "M15.111 8.889a.9.9 0 010 1.273l-1.838 1.837 1.838 1.84a.9.9 0 11-1.273 1.272L12 13.273l-1.838 1.838a.9.9 0 11-1.273-1.273L10.727 12 8.89 10.162a.9.9 0 111.273-1.273L12 10.727l1.837-1.838a.9.9 0 011.273 0z"
  }))));
}

export { SvgError as S };
